import React from "react";
import "./PensionValuesHeader.scss";

const PensionValuesHeader = (props: { imgSrc: any; label: string }) => {
  return (
    <div className="dashboard-table-header-wrapper">
      <img src={props.imgSrc} alt="table1" role="presentation"  />
      <span>{props.label}</span>
    </div>
  );
};

export default PensionValuesHeader;
